import React from 'react';
import * as LucideIcons from 'lucide-react';

/**
 * SahiIcon - Dynamic icon component that renders any Lucide icon by name
 * @param {string} iconName - The name of the Lucide icon (e.g., "CirclePlus", "heart", "circle-plus")
 * @param {string} className - CSS classes to apply to the icon
 * @param {object} props - Any additional props to pass to the icon component
 */
const SahiIcon = ({ iconName, className = "h-4 w-4", ...props }) => {
  if (!iconName) {
    return <LucideIcons.DollarSign className={className} {...props} />;
  }

  // Convert icon name to PascalCase if needed (e.g., "circle-plus" -> "CirclePlus")
  const formatIconName = (name) => {
    return name
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('');
  };

  const formattedIconName = formatIconName(iconName.trim());
  
  // Try to get the icon component - first try formatted name, then original name
  const IconComponent = LucideIcons[formattedIconName] || LucideIcons[iconName] || LucideIcons[iconName.toLowerCase()];

  if (IconComponent) {
    return <IconComponent className={className} {...props} />;
  }

  // Fallback to DollarSign if icon not found
  console.warn(`SahiIcon: Icon "${iconName}" not found in Lucide icons. Using DollarSign as fallback.`);
  return <LucideIcons.DollarSign className={className} {...props} />;
};

export default SahiIcon;